import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Airport } from '../models/airport';

@Injectable({
  providedIn: 'root',
})
export class AirportService {
  constructor(private http: HttpClient) {}

  // Méthode pour rechercher des aéroports
  searchAirports(query: string): Observable<Airport[]> {
    return this.http
      .get<Airport[]>(`${environment.apiUrl}/airports?search=${query}`)
      .pipe(
        map((data) => data || []), // Assure qu'on renvoie un tableau même si la réponse est vide
      );
  }
}
